import NotificationsList from "./NotificationsListDash";

export default NotificationsList;
